<script>
import resources from './resources'

export default {
  name: 'agendas-search-results-item',
  mixins: [resources]
}
</script>

<template lang="pug">
  .item
    modal(
      :visible="showModal",
      :name="'professional' + agenda.id"
      @close="showModal = false"
    )
      professional-profile(:profile="agenda", :key="agenda.professional.id")
    .row
      .col-xs-12.col-sm-4.col-md-2.padding
        div
          .profile-photo
            img.img-circle(:src='agenda.professional.avatar')
          .links
            ul
              //- social linkedin
              a(v-if="agenda.professional.networks.linkedin", :href='agenda.professional.networks.linkedin', target="_blank")
                li
                  img(src='/static/images/icons/linkedin-icon.svg')
              a.mb-cursor-point(v-if="!agenda.professional.networks.linkedin")
                li
                  img(src='/static/images/icons/linkedin-icon.svg')

              //- profile professional
              a(href='#', @click.prevent="showModal = !showModal")
                li
                  img(src='/static/images/icons/perfil-icon.svg')

              //- social professional lattes
              a(v-if="agenda.professional.networks.lattes", :href='agenda.professional.networks.lattes', target="_blank")
                li
                  img(src='/static/images/icons/share-icon.svg')
              a.mb-cursor-point(v-if="!agenda.professional.networks.lattes")
                li
                  img(src='/static/images/icons/share-icon.svg')

              //- favorite professional
              favorite(:professional="agenda.professional_id")

      .col-xs-12.col-sm-8.col-md-10
        .row
          .col-xs-12.col-sm-12.col-md-5
              company_information(
                :name="agenda.company_slug",
                :document="agenda.document",
                :professionalState="agenda.professional_state",
                :speciality="agenda.speciality",
                :companySlug="agenda.company_slug",
                :companyType="agenda.company_type",
                :professionalName="agenda.professional_name",
                :street="agenda.street",
                :number="agenda.number",
                :complement="agenda.complement"
                :zip="agenda.zip",
                :district="agenda.district",
                :city="agenda.city",
                :countryState="agenda.state",
                :isCompany="agenda.is_company",
                v-if="agenda.is_company"
              )

              personal-information(
                :name="agenda.professional.name",
                :document="agenda.document",
                :professionalState="agenda.professional_state",
                :speciality="agenda.speciality",
                :companySlug="agenda.company_slug",
                :companyType="agenda.company_type",
                :professionalName="agenda.professional_name",
                :street="agenda.street",
                :number="agenda.number",
                :complement="agenda.complement"
                :zip="agenda.zip",
                :district="agenda.district",
                :city="agenda.city",
                :countryState="agenda.state",
                v-if="!agenda.is_company"
              )
          .col-xs-12.col-sm-12.col-md-4
            schedule(:agenda="agenda")
          .col-xs-12.col-sm-12.col-md-3
            .planos(v-if="agenda.covenant")
               span(v-for="covenants in agenda.covenant.split(',')" :tag="covenants")
                | {{ covenants }}

            .consulta-particular(v-if="agenda.price")
              small.mb-cursor-point.price-search(@click.prevent="isShowPrice = !isShowPrice")
                span.icon 
                | Consulta Particular

              div(v-show="isShowPrice && agenda._parsed.price_real > 0", style="margin-left: 10px;")
                span.rs R$
                span.valor {{ agenda._parsed.price_real }}
                span.cents ,{{ agenda._parsed.price_cents }}
                span.cents(v-if="!agenda._parsed.price_cents")
                  | 00

              div(v-show="isShowPrice && agenda._parsed.price_real <= 0", style="margin-left: 10px;")
                span.rs Não informado

      .col-xs-12.col-sm-12.col-md-10.col-md-offset-2.border-top(v-if="agenda.latitude && agenda.longitude")
        .ver-mapa(:data-id="agenda.id", v-on:click="isShow = !isShow")
          span.icon 
          | Ver Mapa

      #map.col-xs-12(v-show="isShow", v-if="agenda.latitude && agenda.longitude")
        maps(:latitude="agenda.latitude", :longitude="agenda.longitude")
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/results/components/item/item.vue